import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useCookie } from 'react-use';
import { includes } from 'ramda';
import { UserResource } from '~~apis/resource';
import IconEmail from './assets/IconEmail.svg';
import IconPassword from './assets/IconPassword.svg';
import Button from '../../common/elements/Button';
import Input from '../../common/elements/Input';
import { StyledForm } from './Styles';
import { STATUS } from './LoginConsts';

const CompleteSignUp = ({ platform }) => {
  const [apiStatus, setApiStatus] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');
  const [rawUserData] = useCookie('third_party_register_requirement');
  const resolvedUserData = JSON.parse(Buffer.from(rawUserData, 'base64').toString());
  const { user_name, email, columns } = resolvedUserData;
  const [requireColumns, setRequirColumns] = useState(columns);

  const handleSumbit = (e) => {
    e.preventDefault();

    setApiStatus('LOADING');

    const requestBody = requireColumns.reduce((body, key) => {
      return {
        ...body,
        [key]: e.target[key].value,
      };
    }, {});

    if (!requestBody.email && email) {
      requestBody.email = email;
    }

    UserResource.exists({ email: requestBody.email })
      .then(({ data }) => {
        if (!data.exists || includes('password', requireColumns)) {
          UserResource.thirdPartyRegisterRequirement({ platform, data: requestBody })
            .then(() => {
              setApiStatus('SUCCESS');
              setTimeout(() => {
                window.location.href = process.env.REACT_APP_MAINPAGE_URL;
                window.location.replace(process.env.REACT_APP_MAINPAGE_URL);
              }, 500);
            })
            .catch((error) => {
              return handleError(error.message);
            });
          return;
        }

        requireColumns.push('password');
        setRequirColumns(requireColumns);
        setApiStatus(null);
        return;
      })
      .catch((error) => {
        return handleError(error.message);
      });
  };

  const handleError = (errorCode) => {
    const status = 'ERROR';
    setApiStatus(status);

    let errorMessage = '發生錯誤，請稍後再試，或與聯絡我們。';
    switch (errorCode) {
      case 'INVALID_EMAIL_FORMAT':
        errorMessage = '信箱格式錯誤';
        break;
      case 'WRONG_PASSWORD':
        errorMessage = '密碼錯誤';
        break;
      default:
        break;
    }

    setErrorMsg(errorMessage);
  };

  return (
    <StyledForm onSubmit={handleSumbit} autoComplete="off" status={STATUS.SIGN_IN}>
      <div className="upper-box">
        {includes('password', requireColumns)
          ? `${user_name} 您好，信箱${email}已透過其他註冊方式註冊成功！請輸入密碼以完成 ${platform} 綁定`
          : `${user_name} 您好，請輸入指定資料以完成 ${platform} 註冊程序`}
      </div>
      <div className="bottom-box">
        {requireColumns &&
          requireColumns.map((column) => {
            switch (column) {
              case 'password': {
                return (
                  <div className="input-field" key={column}>
                    <img src={IconPassword} alt="Password" />
                    <Input placeholder="密碼" name="password" type="password" disabled={apiStatus === 'LOADING'} />
                  </div>
                );
              }
              case 'email': {
                return (
                  <div className="input-field" key={column}>
                    <img src={IconEmail} alt="Email" />
                    <Input placeholder="信箱" name="email" type="email" disabled={apiStatus === 'LOADING'} />
                  </div>
                );
              }
              default: {
                throw new Error('Unknown status');
              }
            }
          })}
        <Button boxShadow round width="50%" type="submit" disabled={includes(apiStatus, ['LOADING', 'SUCCESS'])}>
          送出資料
        </Button>
        {errorMsg && <div className="error-msg">{errorMsg}</div>}
      </div>
    </StyledForm>
  );
};

CompleteSignUp.propTypes = {
  platform: PropTypes.string.isRequired,
};

export default CompleteSignUp;
